import { breadcrumbs as util } from '../../../SEO/StructuredData/breadcrumbs';

import config from '../../../SEO/structured_data.config.json';
import { Product } from '@virginexperiencedays/products';

const { website } = config;

const breadcrumbs = ({
  slug,
  title,
  categoryHierarchy,
  pagePathOverride,
}: Product & { pagePathOverride?: string }) => {
  const { lvl0, lvl1, lvl2 } = categoryHierarchy ?? {};
  const pagePath = pagePathOverride || `/product/${slug}`;

  return {
    '@type': 'BreadcrumbList',
    '@id': `${new URL(pagePath, website.url)}#breadcrumb`,
    itemListElement: [
      ...util(lvl2 || lvl1 || lvl0),
      {
        name: title,
        path: pagePath,
        externalLink: false,
      },
    ]
      .filter(({ name, path }) => name && path)
      .map(({ name, path }, index, arr) =>
        index + 1 != arr.length
          ? {
              '@type': 'ListItem',
              position: index + 1,
              name,
              item: new URL(path, website.url),
            }
          : {
              '@type': 'ListItem',
              position: index + 1,
              name,
            }
      ),
  };
};

export default breadcrumbs;
